module.exports = __webpack_public_path__ + "images/marketing/adrian_ossowski_bg.jpg";